module.exports = __webpack_public_path__ + "static/media/double_room_preview.92a5be55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/DoubleRoom/images/double_room_preview.jpg
// module id = 432
// module chunks = 0